﻿var mypageCancelContract = {};

mypageCancelContract = {

  init: function () {

    var form = document.getElementsByClassName('form__cancelContract')[0];

    if (form) {

      var select = form.querySelector('select');

      if (select) {
        select.onchange = function () {

          var val = this.value;

          var el = document.getElementsByClassName('form__cancelContract_reason')[0];

          if (val === 'Annað') {

            el.classList.remove('hide');

          } else {
            el.classList.add('hide');
          }

        };
      }

    }


  }
};

mypageCancelContract.initialize = function () {
  //mypageCancelContract.init();
};

module.exports = mypageCancelContract;
